export default "__VITE_ASSET__BH2$v8Q8__"